import moment from "moment";
export function getNotificationColumns() {

    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
            sorter: (a, b) => a.id - b.id,
            defaultSortOrder: "ascend",
        },
        {
            title: "Заголовок",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Текст",
            dataIndex: "body",
            key: "body",
        },
        {
            title: "Отправлено в",
            dataIndex: "sentAt",
            key: "sentAt",
            render: (text) => (
                <span>{moment(text).format("DD.MM.YYYY HH:mm")}</span>
            ),
        }

    ];
}